import { render, staticRenderFns } from "./member_points_supdeduct_detail.vue?vue&type=template&id=78aa37f1&scoped=true"
import script from "./member_points_supdeduct_detail.vue?vue&type=script&lang=js"
export * from "./member_points_supdeduct_detail.vue?vue&type=script&lang=js"
import style0 from "./member_points_supdeduct_detail.vue?vue&type=style&index=0&id=78aa37f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aa37f1",
  null
  
)

export default component.exports